import Ls from '../../../services/ls'
import * as types from './mutation-types'
import * as userTypes from '../user/mutation-types'
import * as rootTypes from '../../mutation-types'
import router from '../../../router/index'
import { clearBranding } from '../../../composables/useBranding'

export const login = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('login', { email: data.email, password: data.password }).then((response) => {
            const token = response.data.token
            Ls.set('auth.token', token)

            commit('user/' + userTypes.BOOTSTRAP_CURRENT_USER, response.data.user, { root: true })
            commit('user/' + userTypes.SET_CURRENT_SHOP, response.data.shop, { root: true })
            commit(rootTypes.UPDATE_APP_LOADING_STATUS, false, { root: true })
            commit(types.AUTH_SUCCESS, token)

            resolve(response)
        }).catch(err => {
            commit(types.AUTH_ERROR, err.response)
            Ls.remove('auth.token')
            reject(err)
        })
    })
}

export const loginByPhone = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('login/phone', { phone_code: data.phone_code, phone: data.phone, password: data.password }).then((response) => {
            const token = response.data.token
            Ls.set('auth.token', token)

            commit('user/' + userTypes.BOOTSTRAP_CURRENT_USER, response.data.user, { root: true })
            commit('user/' + userTypes.SET_CURRENT_SHOP, response.data.shop, { root: true })
            commit(rootTypes.UPDATE_APP_LOADING_STATUS, false, { root: true })
            commit(types.AUTH_SUCCESS, token)

            resolve(response)
        }).catch(err => {
            commit(types.AUTH_ERROR, err.response)
            Ls.remove('auth.token')
            reject(err)
        })
    })
}

export const register = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('register', data).then((response) => {
            const token = response.data.token
            Ls.set('auth.token', token)

            commit('user/' + userTypes.BOOTSTRAP_CURRENT_USER, response.data.user, { root: true })
            commit('user/' + userTypes.SET_CURRENT_SHOP, response.data.shop, { root: true })
            commit(types.AUTH_SUCCESS, token)

            resolve(response)
        }).catch(err => {
            reject(err)
        })
    })
}

export const createPassword = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('createPassword', data).then((response) => {
            resolve(response)
        }).catch(err => {
            commit(types.AUTH_ERROR, err.response)
            Ls.remove('auth.token')
            reject(err)
        })
    })
}

export const forgetPassword = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('forgetPassword', data).then((response) => {
            resolve(response)
        }).catch(err => {
            reject(err)
        })
    })
}

export const forgetPasswordByPhone = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('forgetPassword/phone', { phone_code: data.phone_code, phone: data.phone }).then((response) => {
            resolve(response)
        }).catch(err => {
            reject(err)
        })
    })
}

export const verifyPhoneResetOtp = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('forgetPassword/phone/verify', data).then((response) => {
            resolve(response)
        }).catch(err => {
            reject(err)
        })
    })
}

export const resetPasswordByPhone = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('resetPassword/phone', data).then((response) => {
            resolve(response)
        }).catch(err => {
            reject(err)
        })
    })
}

export const resetPassword = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('resetPassword', data).then((response) => {
            resolve(response)
        }).catch(err => {
            reject(err)
        })
    })
}

export const logout = ({ commit }, noRequest = false) => {
    if (noRequest) {
        commit(types.AUTH_LOGOUT)
        Ls.remove('auth.token')
        clearBranding()
        router.push('/login')
        return true
    }

    return new Promise((resolve, reject) => {
        window.axios.post('logout').then(() => {
            commit(types.AUTH_LOGOUT)
            Ls.remove('auth.token')
            clearBranding()
            router.push('/login')
            resolve()
        }).catch(() => {
            commit(types.AUTH_LOGOUT)
            Ls.remove('auth.token')
            clearBranding()
            router.push('/login')
        })
    })
}

export const getUserByToken = ({ commit }, token) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/token/' + token + '/user').then((response) => {
            resolve(response)
        }).catch(err => {
            reject(err)
        })
    })
}
